// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/analytics_dashboard/:app_group_id/audience_sync_credit_consumption_detail_data" endpoint
 */
import { isAudienceSyncConsumptionResult } from "@dashboardApi/apis/audienceSyncConsumption/validators";

import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { audienceSyncConsumption } from "./constants";
import type { AudienceSyncConsumptionParams, AudienceSyncConsumptionResult } from "./types";

export const getDataTableAudienceSyncConsumption = reactQueryTableFetcherAdapter(
  audienceSyncConsumption,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 20, start = 0, sortdir, sortby }: AudienceSyncConsumptionParams
  ): Promise<AudienceSyncConsumptionResult> => {
    const { start_date, end_date, app_group: appGroup, provider: provider } = query;

    return fetch(
      `/analytics_dashboard/${appGroupId}/audience_sync_credit_consumption_detail_data`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        start_date: start_date,
        end_date: end_date,
        query: serializeQueryObjects({
          ...(appGroup && { app_group: appGroup }),
          ...(provider && { provider: provider }),
        }),
      },
      { signal }
    );
  },
  isAudienceSyncConsumptionResult
);
